export default function AuthFooter() {
  return (
    <footer className="bg-[#1A1A1A] text-white text-center py-4">
      <div className="container mx-auto">
        <p>&copy; 2025 All rights reserved</p>
      </div>
    </footer>
  );
}